import { Component, OnInit, Input } from '@angular/core';
import { Filter } from '../../../models/filter.model';
import { Column } from '../../../models/column.model';
import { ReportEntity } from '../../../models/report-entity.model';

@Component({
  selector: 'app-column-entity-alias',
  templateUrl: './column-entity-alias.component.html',
  styleUrls: ['./column-entity-alias.component.scss']
})
export class ColumnEntityAliasComponent implements OnInit {

  @Input() item : Filter | Column;

  @Input() reportEntities : Array<ReportEntity> = []

  reportEntity : ReportEntity;

  constructor() { }

  ngOnInit() {
    this.reportEntity = this.reportEntities.find(x => x.Id == this.item.ReportEntityId);
  }

}
